import { render, staticRenderFns } from "./rejectionResubmission.vue?vue&type=template&id=d3dae3b2&scoped=true"
import script from "./rejectionResubmission.vue?vue&type=script&lang=js"
export * from "./rejectionResubmission.vue?vue&type=script&lang=js"
import style0 from "./rejectionResubmission.vue?vue&type=style&index=0&id=d3dae3b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3dae3b2",
  null
  
)

export default component.exports